import { connect } from "react-redux";
import Statistics from "./Statistics";
import { loadStatistics, addNotification } from "@actions";

const mapStateToProps = (state) => {
  return {
    eventId: state.page.params.eventId,
    statistics: state.api.events.statistics.data,
    fetching: state.api.events.statistics.fetching,
    apiUrl: state.api.configuration.url,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadStatistics: (eventId) => {
      return new Promise((resolve, reject) => {
        dispatch(loadStatistics(eventId))
          .then((data) => resolve(data))
          .catch((err) => reject(err));
      });
    },
    addNotification: (notification, status) => {
      dispatch(addNotification(notification, status));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Statistics);
